import { FlaskConical } from "lucide-react";
import { EmptyState } from "@/components/ui/empty-state";

/**
 * Evals Tab - DISABLED
 *
 * The evals functionality is not available in this version.
 * This feature requires proprietary components.
 */
export function EvalsTab() {
  return (
    <div className="flex h-full items-center justify-center">
      <EmptyState
        icon={FlaskConical}
        title="Evals Feature Not Available"
        description="The evaluation testing feature is not available in this version of the inspector."
      />
    </div>
  );
}
